import { Component, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {InductionService} from "../../induction/induction.service";
import {EducationMomService} from "../education-mom.service";
import {EducationMom} from "../education-mom.model";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-view-education-mom',
  templateUrl: './view-education-mom.component.html',
  styleUrls: ['./view-education-mom.component.scss']
})
export class ViewEducationMomComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  meeting!: EducationMom | null;
  isLoading: boolean = true;

  // Track expanded state for each field
  expandedFields: { [key: string]: boolean } = {
    topic: false,
    teachingAid: false,
    observationComment: false,
    suggestions: false
  };

  constructor(
    private route: ActivatedRoute,
    private educationService: EducationMomService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.educationService.getDataById(id).pipe(takeUntil(this._destroyed$)).subscribe(data => {
        this.meeting = data ?? null;
        this.isLoading = false;
      });
    }
  }


  renderSuggestions(content: any): any {
    if (!content) return '';

    let output = content;

    // 1 Extract YouTube URL
    const match = content.match(/<oembed url="([^"]+)"/);
    const url = match ? match[1] : '';

    if (url) {
      // Make URL clickable
      const clickable = `<a href="${url}" target="_blank" rel="noopener" style="color:#1a73e8;text-decoration:underline;">${url}</a>`;

      // 2 Extract Video ID
      let videoId = '';

      if (url.includes('youtu.be/')) {
        videoId = url.split('youtu.be/')[1].split(/[?&]/)[0];
      } else if (url.includes('watch?v=')) {
        videoId = url.split('watch?v=')[1].split(/[?&]/)[0];
      }

      // 3 Replace embed figure with clickable link + iframe
      const iframe = `
      <iframe width="350" height="200"
        src="https://www.youtube.com/embed/${videoId}"
        frameborder="0" allowfullscreen>
      </iframe>
    `;

      output = output.replace(
        /<figure class="media"><oembed[^>]+><\/oembed><\/figure>/g,
        `${clickable}<br>${iframe}`
      );
    }

    return output;
  }

  extractYoutubeUrl(html: string): string {
    if (!html) return '';

    const match = html.match(/<oembed url="([^"]+)"/);
    return match ? match[1] : '';
  }


  getParticipantNames(): string {
    if (!this.meeting?.participants || this.meeting.participants.length === 0) {
      return 'No participants';
    }
    return this.meeting.participants.map(p => p.name).join(', ');
  }

  getTruncatedText(text: string | undefined, wordLimit: number = 50): string {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  }

  // Check if text exceeds word limit
  shouldShowMoreButton(text: string | undefined, wordLimit: number = 50): boolean {
    if (!text) return false;
    return text.split(' ').length > wordLimit;
  }

  // Toggle expanded state
  toggleExpanded(field: string): void {
    this.expandedFields[field] = !this.expandedFields[field];
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
